const initialState = {
    carQuoteList: JSON.parse(localStorage.getItem('carQuoteList')) || null,
};

const carQuoteListReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CAR_QUOTE_LIST':
            localStorage.setItem('carQuoteList', JSON.stringify(action.payload));
            return {
                ...state,
                carQuoteList: action.payload,
            };
        default:
            return state;
    }
};

export default carQuoteListReducer;